// Ingredient Page
$(document).ready(function() {
  $('.sticky-cart__form .product-form__submit').on('click',function(){
    $('.shopify-product-form .product-form__submit').trigger('click');
  });
  $('.iit-container').each(function() {
    var $container = $(this);
    var $tabTitles = $container.find('.iit-tab-title');
    var $ingredientbox = $container.find('.iit-ingredient-box');
    var $ingredientinnerbox = $container.find('.iit-ingredient-inner-box');
    var $popupcontainer = $container.find('.iit-popup-container');
    
    $tabTitles.click(function() {
      $tabTitles.removeClass('active');
      $ingredientbox.removeClass('active');
      var tabTitle = $(this).attr('tab-title');
      var count = 0;
      
      $ingredientbox.each(function() {
        if($(this).attr('tab-title') == tabTitle ) {
          if(count == 0){
            $ingredientinnerbox.removeClass('active');
            $popupcontainer.removeClass('active');
            $(this).find('.iit-ingredient-inner-box').addClass('active');
            var ingredient = $(this).find('.iit-ingredient-inner-box').attr('ingredient-title');
            $popupcontainer.each(function() {
              if($(this).attr('ingredient-title') == ingredient ) {
                $(this).addClass('active');
              }
            });
            count++;
          }
          $(this).addClass('active');
        }
      }); 
      
      $(this).addClass('active');
    });
    
    $ingredientinnerbox.click(function() {
      $ingredientinnerbox.removeClass('active');  
      $popupcontainer.removeClass('active');
      var ingredient = $(this).attr('ingredient-title');
      $popupcontainer.each(function() {
        if($(this).attr('ingredient-title') == ingredient ) {
          $(this).addClass('active');
          if ($(window).width() < 750) {
            $(this).addClass('open');
          } else {
            $('.iit-popup-container').removeClass('open');
          }
        }
      });
      $(this).addClass('active');
    });
  });
  $('.ingredient-close-popup').click(function() {
    $('.iit-popup-container').removeClass('open');
  });
  
  $('.iip-popup-btn').click(function() {
    $('.iip-popup-container').addClass('open');
    $('body').addClass('overflow-hidden');
  });
  $('.iip-close-popup').click(function() {
    $('.iip-popup-container').removeClass('open');
    $('body').removeClass('overflow-hidden');
  });
  setTimeout(function(){
    $('.variant-input-wrapper [type="radio"]:checked').trigger('change');
  },2000);



var ulElements = document.querySelectorAll('.shopify_subscriptions_app_block_label_children');

ulElements.forEach(function(ul) {
    var liElements = ul.querySelectorAll('li');
    liElements.forEach(function(li, index) {
        var label = li.querySelector('label');
        if (label) {
            var input = label.querySelector('input');
            if (input) {
                
                var variantPrice = parseFloat(input.getAttribute('data-variant-price').replace('$', '').replace(' USD', ''));
                var compareAtPrice = parseFloat(input.getAttribute('data-variant-compare-at-price').replace('$', '').replace(' USD', ''));
                var discountPercentage = ((compareAtPrice - variantPrice) / compareAtPrice) * 100;

               
                if (index === liElements.length - 1) { 
                    var discountSpan = document.createElement('span');
                    discountSpan.textContent = `(save ${Math.round(discountPercentage)}%)`;
                    discountSpan.style.display = 'block'; 
                  discountSpan.style.marginLeft  = 'auto';
                  discountSpan.style.fontWeight = '200'; 
                    ul.appendChild(discountSpan); 
                }

               
                var newText = document.createTextNode(' Subscribe and Save');

                
                while (label.firstChild) {
                    label.removeChild(label.firstChild);
                }

               
                label.appendChild(input);
                label.appendChild(newText);

              
                if (index === 0) { 
                    input.checked = true;
                }
            }
        }
    });
  
});


var hiddenElements = document.querySelectorAll('.shopify_subscriptions_app_block--hidden');


hiddenElements.forEach(function(element) {
    element.classList.remove('shopify_subscriptions_app_block--hidden');
});
  

var targetUls = document.querySelectorAll(".shopify_subscriptions_app_block_label_children");


targetUls.forEach(function(targetUl) {
    
    var targetLi = targetUl.querySelector("li");
    

    var priceDiv = targetUl.closest('.shopify_subscriptions_app_block_label').querySelector(".shopify_subscriptions_in_widget_price.allocation_price");

   
    if (targetLi && priceDiv) {
      
        targetLi.insertAdjacentElement('afterend', priceDiv);
    }
});


document.querySelectorAll('.shopify_subscriptions_app_block_label label').forEach(function(label) {
   
    if (!label.closest('.shopify_subscriptions_purchase_option_wrapper') ||
        label.closest('.shopify_subscriptions_app_block_label.shopify_subscriptions_purchase_option_wrapper')) {
        
        label.style.fontWeight = 'bold';
        label.style.textTransform = 'capitalize';
    }
});

});

$(function(){
    $('.shopify_subscriptions_app_block').addClass('shopify_subscriptions_app_block--hidden');
     var variant_id = $('.variant-input-wrapper [type="radio"]:checked').next('[data-variant-id]').data('variant-id');
    $('.shopify_subscriptions_app_block[data-variant-id="'+variant_id+'"]').removeClass('shopify_subscriptions_app_block--hidden');
    $('[name="id"]').val(variant_id);
});

document.addEventListener('DOMContentLoaded', function() {
    let sellingPlanRadios = document.querySelectorAll("input[type='radio'][data-radio-type='selling_plan']");
    sellingPlanRadios.forEach(radio => {
        
        radio.closest('.shopify_subscriptions_app_block_label').style.backgroundColor = '#f0f0e2';
        radio.closest('.shopify_subscriptions_app_block_label').style.setProperty('border-color', '#1D1D1B', 'important');
    });

    
    let oneTimePurchaseRadios = document.querySelectorAll("input[type='radio'][data-radio-type='one_time_purchase']");
    oneTimePurchaseRadios.forEach(function(radio, index) {
        radio.addEventListener('change', function() {
            
            this.closest('.shopify_subscriptions_purchase_option_wrapper').style.backgroundColor = '#f0f0e2';
            this.closest('.shopify_subscriptions_purchase_option_wrapper').style.setProperty('border-color', '#1D1D1B', 'important');

            
            if (sellingPlanRadios[index]) {
                sellingPlanRadios[index].closest('.shopify_subscriptions_app_block_label').style.backgroundColor = '';
                sellingPlanRadios[index].closest('.shopify_subscriptions_app_block_label').style.setProperty('border-color', '');
            }
        });
    });

    
    sellingPlanRadios.forEach(function(radio, index) {
        radio.addEventListener('change', function() {
            
            this.closest('.shopify_subscriptions_app_block_label').style.backgroundColor = '#f0f0e2';
            this.closest('.shopify_subscriptions_app_block_label').style.setProperty('border-color', '#1D1D1B', 'important');
            
           
            if (oneTimePurchaseRadios[index]) {
                oneTimePurchaseRadios[index].closest('.shopify_subscriptions_purchase_option_wrapper').style.backgroundColor = '';
                oneTimePurchaseRadios[index].closest('.shopify_subscriptions_purchase_option_wrapper').style.setProperty('border-color', '');
            }
        });
    });
});



document.addEventListener("DOMContentLoaded", function() {
 

function makeParentClickable(containerSelector, parentSelector, radioSelector) {
  
  const container = document.querySelector(containerSelector);
  
  if (!container) {
    console.warn('Container for makeParentClickable not found:', containerSelector);
    return;
  }

  
  container.addEventListener('click', function(e) {
    
    const parent = e.target.closest(parentSelector);

   
    if (parent && e.target.type !== 'radio') {
     
      const radioButton = parent.querySelector(radioSelector);
     
      if (radioButton && !radioButton.checked) {
      
        e.preventDefault();
        
        radioButton.click();
      }
    }
  });
}


makeParentClickable('body', '.shopify_subscriptions_app_block_label', 'input[type="radio"]');

 

  const fieldsets = Array.from(document.querySelectorAll('fieldset'));
  const targetFieldset = fieldsets.find(fieldset => {
    
    return fieldset.querySelectorAll('input[type="radio"]').length > 0 && 
           fieldset.querySelector('legend').textContent.toLowerCase().includes("dog's size");
  });

  if (!targetFieldset) return; 

  const labels = targetFieldset.querySelectorAll('label');

  labels.forEach(label => {
    
    let contents = label.innerHTML.split('<br>');
    let size = contents[0].trim();
    let weight = contents[1].replace('&lt;', '<').replace('&gt;', '>').trim();

   
    const boldSize = document.createElement('b');
    boldSize.textContent = size;

    const spanWeight = document.createElement('span');
    spanWeight.innerHTML = weight; 

    label.innerHTML = '';
    label.appendChild(boldSize);
    label.appendChild(spanWeight);
  });

  
});

function getSelectedDogSize() {
    var sampleRadioButton = document.querySelector('.variant-input-wrapper input[type="radio"]');
    var fieldName = sampleRadioButton ? sampleRadioButton.name : null;

    if (fieldName) {
        var querySelectorString = `.variant-input-wrapper input[name="${fieldName}"]:checked`;
        var selectedSizeRaw = document.querySelector(querySelectorString).getAttribute('data-option-value');

        console.log(selectedSizeRaw); 

        var selectedSize = selectedSizeRaw.split(" ")[0];
        console.log("Selected dog size:", selectedSize);

        var daySupply = selectedSize === 'Small' ? '60-day supply' : '30-day supply';

        document.querySelector('.variant-selected-supply').textContent = daySupply;
    } else {
        console.error('Field name not found.');
    }
}

getSelectedDogSize();

var fieldName = document.querySelector('.variant-input-wrapper input[type="radio"]')?.name;
if (fieldName) {
    document.querySelectorAll(`.variant-input-wrapper input[name="${fieldName}"]`).forEach(function(input) {
        input.addEventListener('change', getSelectedDogSize);
    });
} else {
    console.error('Unable to add event listeners: Field name not found.');
}
 document.querySelectorAll('.shopify_subscriptions_in_widget_price, label').forEach(function(node) {
    node.innerHTML = node.innerHTML.replace(/\$([0-9,.]+) USD/g, '$$$1');
});